// First: global.css declares the order of the CSS layers for the dev server. A component imported
// before it would declare `pix-components` first, the lowest layer, and Tailwind's base would reset
// the pattern library's buttons. The build links the components' CSS before this file's, so
// index.html declares the same order before any stylesheet.
import "./global.css";
import { createApp } from "vue";
import { VueQueryPlugin } from "@tanstack/vue-query";
import App from "./App.vue";
import { createPortalQueryClient } from "./api/query-client.ts";
import { createPortalI18n } from "./i18n/i18n.ts";
import { monitorAfterConsent } from "./lib/monitoring.ts";
import { createPortalRouter, handleSessionLost } from "./router/index.ts";

// One cache for server data (ADR-076); a 401 anywhere ends the session in the UI and opens the
// login with the way back.
const queryClient = createPortalQueryClient({ onUnauthenticated: () => handleSessionLost(router, queryClient) });
const router = createPortalRouter({ queryClient });

// The texts of the packages load before the first render, so no component shows a bare key.
const i18n = await createPortalI18n();

createApp(App).use(VueQueryPlugin, { queryClient }).use(router).use(i18n).mount("#app");

// Faro, only after consent to "Statistik" (ADR-141 points 4 and 5).
monitorAfterConsent(router);
